import React, { useMemo, useRef } from "react"
import { motion } from "framer-motion"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { getRandomNumber } from "utils/numberUtils"
import { useAppSelector } from "appRedux/hooks"
import { getStaticAssetUrl } from "appRedux/baseQuery"
import LazyImage from "components/atoms/LazyImage"
import WishItemBottomSection from "components/organisms/WishItemBottomSection"

type WishItemSlideProps = {
  itemInfo: WishItem;
  index: number;
}

export default function WishItemSlide(props: WishItemSlideProps) {
  const { itemInfo, index } = props

  const wishListState = useAppSelector((state) => state.wishList)

  const imageContainerRef = useRef<HTMLDivElement | null>(null)

  const randomPlaceholderIndex = useMemo(() => getRandomNumber(1, 10), [index])

  const item = wishListState.itemInfo?.id === itemInfo?.id ? wishListState.itemInfo : itemInfo

  function renderItemImage() {
    if (itemInfo.image instanceof File && itemInfo.image.size > 0) {
      const fileReader = new FileReader()

      fileReader.onload = () => {
        if (!imageContainerRef.current) return
        imageContainerRef.current.style.backgroundImage = `url(${fileReader.result as string})`
      }

      fileReader.readAsDataURL(itemInfo.image)
    } else {
      return <LazyImage
        src={typeof itemInfo.image === "string" ? getStaticAssetUrl(itemInfo.image) : null}
        alt={itemInfo.name}
        placeholder={`/static/images/placeholder/no-image-${randomPlaceholderIndex}.svg`}
        theme="dark"
        style={{ objectFit: "contain" }}
        placeHolderStyle={{ width: "40%", height: "auto" }}
      />
    }
  }

  return (
    <ItemContainer>
      <Stack width={"100%"}>
        <ImageContainer ref={imageContainerRef} id={"image-container"}>
          {renderItemImage()}
        </ImageContainer>
      </Stack>
      {/*@ts-ignore*/}
      <WishItemBottomSection
        {...item}
        containerId="wishlist-slider-view"
      />
    </ItemContainer>
  )
}

const ItemContainer = styled(motion.div)(({ theme }) => ({
  display: "flex",
  width: "100%",
  height: "100%",
  flexShrink: 0,
  position: "relative",

  "& .MuiTextField-root": {
    marginBottom: "0 !important",

    "& .MuiInputBase-root": {
      border: "none"
    }
  }
}))

const ImageContainer = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100%",
  overflow: "hidden",
  justifyContent: "center",
  alignItems: "center",
  backgroundSize: "contain",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  zIndex: -1
}))
